import { render, staticRenderFns } from "./NuevoUsuario.vue?vue&type=template&id=2729d789"
import script from "./NuevoUsuario.vue?vue&type=script&lang=js"
export * from "./NuevoUsuario.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports